import { isEmpty } from "lodash";

export const DEFAULT_BOX_HEIGHT = 210;
export const DEFAULT_BOX_WIDTH = 270;

class ProductListController {
  COLUMNS = 3;
  HIGHLIGHT_PRODUCT_SIZE = 2;

  COLUMNS_WIDE = 1;
  HIGHLIGHT_PRODUCT_SIZE_WIDE = 1;

  constructor(
    productsToShow,
    currentCategory,
    bigItem,
    maxHeight,
    productListElemContainer
  ) {
    this.productsToShow = productsToShow;
    this.currentCategory = currentCategory;
    this.bigItem = bigItem;
    this.isWide = currentCategory.list_layout === 1;
    this.layoutSettings = this.getLayoutSettings();
    this.maxHeight = maxHeight;
    this.productListElemContainer = productListElemContainer;

    this.positionsByIndex = [];
    this.listState = {
      rowCount: 0,
      rowsVisible: 5
    };
  }

  static getBoxWidth() {
    return DEFAULT_BOX_WIDTH;
  }

  static getBoxHeight() {
    return DEFAULT_BOX_HEIGHT;
  }

  getLayoutSettings() {
    return {
      COLUMNS: this.getCurrentLayoutColumnCount(),
      HIGHLIGHT_PRODUCT_SIZE: this.getCurrentLayoutHighlightProductSize()
    };
  }

  getCurrentLayoutColumnCount() {
    return this.isWide ? this.COLUMNS_WIDE : this.COLUMNS;
  }

  getCurrentLayoutHighlightProductSize() {
    return this.isWide
      ? this.HIGHLIGHT_PRODUCT_SIZE_WIDE
      : this.HIGHLIGHT_PRODUCT_SIZE;
  }

  calculatePositionsByIndex() {
    let column = 0;
    let line = 0;
    let skip = [];
    let relayout_ctr = 0;
    this.productsToShow.forEach(p => {
      for (;;) {
        //inner loop needed for relayout when a big product does not fit.
        if (column >= this.layoutSettings["COLUMNS"]) {
          //proceed to next line if current column exceeds layoutSettings["COLUMNS"].
          column = 0;
          line += 1;
        }
        if (skip.find(s => s[0] === column && s[1] === line)) {
          //is current (column, line) in skip (occupied)?
          column += 1;
          continue;
        }

        if (relayout_ctr > 0) {
          //relayout_ctr > 0 means we are currently in a relayout phase.
          this.positionsByIndex[
            this.positionsByIndex.length - relayout_ctr - 1
          ] = [column, line];
          column += 1;
          relayout_ctr -= 1;
          if (relayout_ctr === 0) break; // we are done relayouting proceed with the next product.
          continue; // we have more stuff to relayout, proceed with that.
        }

        //WE SHOULD NOT REACH HERE AGAIN UNTIL RELAYOUT IS COMPLETED!
        if (
          this.currentCategory &&
          this.currentCategory.highlight_product === p.id &&
          this.bigItem
        ) {
          // We need to layout a hightlight_product
          if (
            column + this.layoutSettings["HIGHLIGHT_PRODUCT_SIZE"] >
            this.layoutSettings["COLUMNS"]
          ) {
            //is the new highlight product exceeding available columns?
            relayout_ctr =
              (column + this.layoutSettings["HIGHLIGHT_PRODUCT_SIZE"]) %
              this.layoutSettings["COLUMNS"]; //do relayout in that case.
            column -= relayout_ctr; //new columns position for product (we proceed to next line and column 0 later)
          }
          for (
            let dx = 0;
            dx < this.layoutSettings["HIGHLIGHT_PRODUCT_SIZE"];
            dx++
          ) {
            // We block what we need to display this highlight here.
            for (
              let dy = 0;
              dy < this.layoutSettings["HIGHLIGHT_PRODUCT_SIZE"];
              dy++
            ) {
              skip.push([column + dx, line + dy]);
            }
          }
        }
        this.positionsByIndex.push([column, line]); //save our own position.
        if (relayout_ctr > 0) {
          // we are in a relayout phase reset line to the next and column to 0 so we can start the relayout.
          line += 1;
          column = 0;
          continue;
        }
        column += 1;
        break;
      }
    });

    return this.positionsByIndex;
  }

  setDelay() {
    let currentColumnLayout = this.getCurrentLayoutColumnCount(this.isWide);
    let delay = [];
    if (this.listState.rowCount <= this.listState.rowsVisible) {
      this.productsToShow.forEach((product, index) => {
        delay.push(index * 50 + "ms");
      });
    } else {
      this.productsToShow.forEach(() => {
        delay.push(0 + "ms");
      });
      let rowScroll = this.listState.rowsVisible + 2;
      let counter =
        this.listState.rowCount < rowScroll ? rowScroll - 1 : rowScroll;
      let startDelay = counter * currentColumnLayout * 50;
      delay.forEach((delayValue, index) => {
        if (index <= counter * currentColumnLayout) {
          delay[index] = startDelay - index * 50 + "ms";
        }
      });
    }
    return delay;
  }

  setRowCountAndRowsVisible() {
    if (isEmpty(this.positionsByIndex)) {
      console.log("positions_by_index missing");
      return;
    }
    let rowIndexes = this.positionsByIndex.map(pos => pos[1]);
    this.listState["rowCount"] = Math.max(...rowIndexes) + 1;
    console.log(
      "setRowCountAndRowsVisible rowCount = " + this.listState["rowCount"]
    );

    if (this.maxHeight !== -1) {
      this.listState["rowsVisible"] = Math.floor(
        this.maxHeight / ProductListController.getBoxHeight()
      );
    } else {
      if (
        this.productListElemContainer &&
        this.productListElemContainer.clientHeight
      ) {
        this.listState["rowsVisible"] = Math.floor(
          this.productListElemContainer.clientHeight /
            ProductListController.getBoxHeight()
        );
      }
    }
    console.log(
      "setRowCountAndRowsVisible rowsVisible = " + this.listState["rowsVisible"]
    );
    return this.listState;
  }
}

export { ProductListController };
